<template>
  <li>
    <div class="contentsWrap reviewCard">
      <div class="iconWithName">
        <div class="icon">
          <img :src="src(community.user.image_url)" />
        </div>
        <div class="name">{{ community.user.name }}</div>
        <content-info
            v-if="showInfo(community)"
            :user-id="community.user_id"
            :content-type="2"
            :content-id="community.id"
        ></content-info>
      </div>
      <div class="text">
        <h3 class="title">{{ community.title }}</h3>
        <slide-photos
          :photos="community.photos"
          :imagePath="image_path"
          customClass="communityPhoto"
        ></slide-photos>
        <p class="content" v-if="!open">
          {{ content }}
          <span
            class="more"
            v-if="community.content.length > contentLength"
            @click.prevent="open = !open"
            >…もっと見る</span
          >
        </p>
        <p class="content" v-if="open">
          {{ community.content }}
          <span class="more close" @click.prevent="open = !open">閉じる</span>
        </p>
        <div class="date">{{ community.created_at }}</div>
      </div>
    </div>
    <div class="comments">
      <community-comment
        :comments="community.comments"
        :shop_id="community.shop_id"
        :parent_comment_id="community.id"
        :image_path="image_path"
        :is_login="is_login"
        :user="user"
      ></community-comment>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    community: Object,
    image_path: String,
    is_login: Boolean,
    user: Object,
  },
  data: () => ({
    contentLength: 50,
    open: false,
    image: '',
  }),
  computed: {
    content() {
      return this.community.content.substr(0, this.contentLength);
    },
  },
  methods: {
    src(url) {
      if (this.$_.isEmpty(url)) {
        return '/img/aloco_img_2.svg';
      } else {
        return this.image_path + url;
      }
    },
    showInfo(community) {
      if (this.user) {
        if (this.is_login && this.user.id !== community.user_id) {
          return true
        }
      }
      return false
    }
  }
}
</script>

<style>
.title, .content {
  white-space: pre-line;
  word-break: break-all;
}
</style>
